import { Component, DOCUMENT, inject, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'public-redirect',
    templateUrl: './redirect.component.html',
    styleUrls: ['./redirect.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: true
})
export class RedirectComponent {
    private document = inject<Document>(DOCUMENT);
    private route = inject(ActivatedRoute);

    constructor() {
        this.document.defaultView.location.replace(this.route.snapshot.data.url);
    }
}
